import React from "react";
import PropTypes from "prop-types";
import AccountName from "components/v3/subscription-details/account-name/AccountName";
import AccountStatus from "components/v3/subscription-details/account-status/AccountStatus";
import SubscriptionStartDate from "components/v3/subscription-details/subscription-start-date/SubscriptionStartDate";
import SubscriptionEndDate from "components/v3/subscription-details/subscription-end-date/SubscriptionEndDate";
import AccountNextBilling from "components/v3/subscription-details/account-next-billing/AccountNextBilling";
import ShippingAddress from "components/v3/subscription-details/shipping-address/ShippingAddress";
import { pricingStrategy, determineProductDisplayName } from "components/v3/subscription-details/util";
import styles from "../styles.module.scss";

const ZuoraSubscriptionDetails = (props) => {
    const {
        type,
        startDate,
        endDate,
        metadata = {},
        ratePlan: {
            offerType,
            billingPeriod,
            promotionType
        } = {},
        hideShippingInfo = false,
        status,
        bloombergSiteUrl,
        id,
        contacts
    } = props;

    const accountName = metadata?.productType;

    const {
        nextChargePrice,
        nextChargeDate
    } = pricingStrategy(metadata);

    const productName = determineProductDisplayName(type, accountName, null, offerType);

    const shippingInfoModule = hideShippingInfo || !contacts || !contacts[0]
        ? null
        : <ShippingAddress contact={ contacts[0] } />;

    return (
        <div>
            <div className={ styles.details }>
                <AccountName name={ productName } />
                <AccountStatus status={ status } bloombergSiteUrl={ bloombergSiteUrl } />
                <SubscriptionStartDate startDate={ startDate } />
                <SubscriptionEndDate status={ status } endDate={ endDate } />
                <AccountNextBilling
                    status={ status }
                    billingPeriod={ billingPeriod }
                    nextRenewalDate={ nextChargeDate }
                    renewalPrice={ nextChargePrice }
                    showCancelLink={ true }
                    showRenewalPrice={ true }
                    productType={ type }
                    subscriptionId={ id }
                    promotionType={ promotionType }
                />
            </div>
            { shippingInfoModule }
        </div>
    );
};

ZuoraSubscriptionDetails.propTypes = {
    type: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string,
    metadata: PropTypes.shape({
        productType: PropTypes.string
    }),
    ratePlan: PropTypes.object,
    hideShippingInfo: PropTypes.bool,
    status: PropTypes.string.isRequired,
    bloombergSiteUrl: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    contacts: PropTypes.array
};

export default ZuoraSubscriptionDetails;
